export const ROLEX_BRAND_ID = "67984672f23c99a95a4261ec";
export const ROLEX_BRAND_SLUG = "rolex";

export const getEntityId = (value) => {
  if (!value) return "";
  if (typeof value === "object") {
    return String(value._id || value.id || value.value || "");
  }
  return String(value);
};

export const isRolexBrandId = (value) => getEntityId(value) === ROLEX_BRAND_ID;

export const isRolexBrandName = (value = "") => {
  const normalized = String(value).trim().toLowerCase();
  return normalized === "rolex" || normalized === "rolex watches";
};

export const isRolexBrand = (brand) =>
  isRolexBrandId(brand) || isRolexBrandName(brand?.name || brand?.brand || brand);

export const isRolexProduct = (product, brandMap = {}) => {
  const brandValue = product?.brand;
  const brandId = getEntityId(brandValue);
  const brandName =
    brandValue?.name ||
    product?.brandName ||
    (typeof brandValue === "string" && !isRolexBrandId(brandValue) ? brandValue : "") ||
    brandMap[product?._id] ||
    "";
  const slug = String(product?.slug || "").trim().toLowerCase();
  const title = String(product?.title || product?.name || "").trim().toLowerCase();

  return (
    isRolexBrandId(brandId) ||
    isRolexBrandName(brandName) ||
    slug.startsWith("rolex-") ||
    title.startsWith("rolex ")
  );
};

export const filterRolexBrands = (brands = []) =>
  (Array.isArray(brands) ? brands : []).filter((brand) => !isRolexBrand(brand));

export const filterRolexProducts = (products = [], brandMap = {}) =>
  (Array.isArray(products) ? products : []).filter((product) => !isRolexProduct(product, brandMap));

export const filterRolexIds = (ids = []) =>
  (Array.isArray(ids) ? ids : []).filter((id) => !isRolexBrandId(id));

export const isRolexCatalogLocation = (pathname = "", search = "") => {
  const normalizedPath = String(pathname).toLowerCase();
  if (/\/catalog\/rolex(?:\/|$)/.test(normalizedPath)) return true;

  const params = new URLSearchParams(search || "");
  const brandParam = params.get("brand") || "";
  return isRolexBrandId(brandParam) || isRolexBrandName(brandParam);
};

export const isRolexPublicPath = (path = "") => {
  const normalized = String(path).toLowerCase();
  return (
    /(^|\/)rolex(\/|$)/.test(normalized) ||
    normalized.includes("sell-rolex-watch") ||
    normalized.includes("rolex-new-watches") ||
    normalized.includes("selling-a-rolex") ||
    normalized.includes("new-luxury-watch-releases-guide")
  );
};

export const sanitizeRolexText = (value = "") => {
  if (typeof value !== "string") return value;

  return value
    .replace(/Rolex,\s*/g, "")
    .replace(/,\s*Rolex/g, "")
    .replace(/Rolex\s*&\s*/g, "")
    .replace(/\s*&\s*Rolex/g, "")
    .replace(/\bRolex watches\b/gi, "luxury watches")
    .replace(/\bRolex watch\b/gi, "luxury watch")
    .replace(/\bRolex\b/g, "luxury watch")
    .replace(/\s+,/g, ",")
    .replace(/,\s*,/g, ",")
    .replace(/\s{2,}/g, " ")
    .trim();
};

export const sanitizeRolexContent = (value) => {
  if (typeof value === "string") {
    return sanitizeRolexText(value);
  }

  if (Array.isArray(value)) {
    return value
      .filter((item) => {
        if (typeof item === "string") return !isRolexPublicPath(item);
        return !isRolexPublicPath(item?.href || item?.path || item?.slug || "");
      })
      .map(sanitizeRolexContent);
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, sanitizeRolexContent(item)])
    );
  }

  return value;
};
